import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import loanSeniorities from "constants/loanSeniorityTypes";
import styled from "styled-components";
import numberFormatter from "utils/numberFormatter";

import {
  ChildSectionTitle,
  SideLabelTextAreaWithRefInput,
  SideLabelMoneyInput,
  SideLabelCalculatedField
} from "../FormSectionComponents";
import mezzFundingStructures from "../../../../constants/mezzFundingStructures";

const loanTypes = require("constants/loanTypes");

const AdditionalAdvancesGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class AdditionalAdvancesChildSection extends React.Component {
  render() {
    const { isEditing, formik } = this.props;

    return (
      <div id="loan_section_additional_advances">
        <ChildSectionTitle>Additional Advances</ChildSectionTitle>
        <AdditionalAdvancesGrid container alignItems="center" direction="column">
          <SideLabelCalculatedField
            label="Maximum Advance"
            calculationFunc={fieldValues => {
              const amount = _.get(fieldValues, "details.amount");
              const initialProceeds = _.get(fieldValues, "details.initialProceeds");
              if (!initialProceeds || initialProceeds == 0) {
                return "--";
              }
              if (formik.values.details.loanSeniorityId === loanSeniorities.SENIOR) {
                const loanTypeId = formik.values.details.loanTypeId;
                if (loanTypeId != loanTypes.default.CONSTRUCTION &&
                          loanTypeId != loanTypes.default.VALUE_ADD &&
                          loanTypeId != loanTypes.default.LINE_OF_CREDIT
                ) {
                  return "--";
                }
              } else if (formik.values.details.loanSeniorityId === loanSeniorities.SUBORDINATE) {
                if (formik.values.details.mezzFundingStructureId == mezzFundingStructures.SEQUENTIAL) {
                  return "--";
                }
              }

              return numberFormatter.formatMoney(parseFloat(amount) - parseFloat(initialProceeds));
            }}
            placeholder="Maximum Advance"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Additional Advance Alloc."
            hasBorder
            placeholder="Additional Advance Alloc."
            fieldName="additionalAdvances.additionalAdvanceAllocations"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Notice for Advance"
            hasBorder
            placeholder="Notice for Advance"
            fieldName="additionalAdvances.noticeForAdvance"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Frequency of Draws"
            hasBorder
            placeholder="Frequency of Draws"
            fieldName="additionalAdvances.drawFrequency"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Draw Threshold/Intervals"
            hasBorder
            placeholder="Draw Threshold/Intervals"
            fieldName="additionalAdvances.drawThresholdInterval"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Conditions for Draws"
            hasBorder
            placeholder="Conditions for Draws"
            fieldName="additionalAdvances.drawConditions"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Required Equity"
            hasBorder
            placeholder="Required Equity"
            fieldName="additionalAdvances.requiredEquity"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Completion"
            hasBorder
            placeholder="Completion"
            fieldName="additionalAdvances.completion"
            isDisabled={!isEditing}
          />

          <SideLabelMoneyInput
            label="Development Fee"
            fieldName="additionalAdvances.developmentFee"
            placeholder="Development Fee"
            isDisabled={!isEditing}
            hasBorder
          />
          <SideLabelTextAreaWithRefInput
            label="Budget/Cost Overruns"
            hasBorder
            placeholder="Budget/Cost Overruns"
            fieldName="additionalAdvances.budgetCostOverruns"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Restoration/Retainage"
            hasBorder
            placeholder="Restoration/Retainage"
            fieldName="additionalAdvances.restorationRetainage"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Covenants"
            hasBorder
            placeholder="Covenants"
            fieldName="additionalAdvances.covenants"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Change Orders"
            hasBorder
            placeholder="Change Orders"
            fieldName="additionalAdvances.changeOrders"
            isDisabled={!isEditing}
          />

          <SideLabelTextAreaWithRefInput
            label="Misc."
            placeholder="Misc."
            fieldName="additionalAdvances.misc"
            isDisabled={!isEditing}
          />
        </AdditionalAdvancesGrid>
      </div>
    );
  }
}
export default AdditionalAdvancesChildSection;
